<template>
    <div v-if="products.length > 0">
        <div class="row" v-if="$root.mobile === false">
            <div class="col align-self-center">
                <h3>{{ translations['Random products'] }}</h3>
                <div class="tooltip">
                    <span class="tooltip-icon">?</span>
                    <div class="tooltip-content">{{ translations['Do you want to try your luck? Add one or more random products to your order! You can get any product of chosen category for lower price!'] }}</div>
                </div>
            </div>
        </div>
        <div class="row" v-if="$root.mobile">
            <div class="col align-self-center text-center">
                <h3>{{ translations['Add to cart'] }}</h3>
            </div>
        </div>
        <div class="row random-products mb-2">
            <div class="col product-box product-line">
                <div v-for="product in products" :key="product.id">
                    <product-line-small :product="product" />
                </div>
            </div>
            <div class="slider-white--controls text-center d-mobile-only">
                <img src="/themes/realgeek/img/chevron-left.svg" class="random-products--controls--left-button">
                <img src="/themes/realgeek/img/chevron-right.svg" class="random-products--controls--right-button">
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import ProductLineSmall from "./ProductLineSmall";

    import './../../../node_modules/tiny-slider/src/tiny-slider.scss';
    import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

    export default {
        components: {ProductLineSmall},
        data() {
            return {
                sliderInitialized: false
            }
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: function (state) {
                    if (this.$root.mobile) {
                        return state.randomProducts.filter(item => item.attributes.length === 0);
                    }
                    return state.randomProducts.slice(0, 3)
                },
            })
        },
        updated(){
            ((mobile) => {
                if (mobile === false || this.sliderInitialized === true) {
                    return;
                }
                tns({
                    container: '.random-products .product-box',
                    items: 1,
                    controls: true,
                    nav: false,
                    gutter: 15,
                    prevButton: '.random-products .random-products--controls--left-button',
                    nextButton: '.random-products .random-products--controls--right-button',
                    responsive: {
                        320: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1350: {
                            disable: true,
                        },
                    }
                });
                this.sliderInitialized = true;
            })(this.$root.mobile);
        },
    }
</script>
<style scoped lang="scss">
    h3 {
        font-size: 24px;
        font-weight: 700;
        text-transform: uppercase;
        display: inline-block;
    }
    .tooltip {
        display: inline-block;
        position: relative;
        top: -0.2rem;
        .tooltip-icon {
            border: 3px solid #cecece;
            border-radius: 20px;
            color: #cecece;
            display: block;
            height: 28px;
            width: 28px;
            padding-left: 7px;
            font-weight: 700;
            margin-left: 5px;
        }
        .tooltip-content {
            display: none;
            position: absolute;
            font-size: 12px;
            top: -6rem;
            left: -9rem;
            width: 350px;
            background-color: #1a1a1a;
            color: #ffffff;
            padding: 10px 20px;
            border-radius: 8px;
            z-index: 10;
        }

        &:hover .tooltip-content {
            display: block;
        }
    }
    .slider-white--controls {
        img {
            width: 10px;
            height: 20px;
        }
    }
    @media (max-width: 1349px) {
        h3{
            text-align: center;
            font-size: 18px;
        }
        .random-products {
            overflow: hidden;
            max-width: 100%;
            margin-left: 0;
            display: block;

            .product-box {
                max-width: unset;
            }

            .random-products--controls--left-button {
                position: absolute;
                top: 80px;
                left: 10px;
                width: 10px;
            }

            .random-products--controls--right-button {
                position: absolute;
                top: 80px;
                right: 10px;
                width: 10px;
            }
        }


    }
</style>
